import { Outlet } from 'react-router-dom';

export const FeatureTestRoutes = () => {
  const energiplanEnabled = window.config.VITE_FEATURE_ENERGIPLAN_ENABLED;

  if (!energiplanEnabled) {
    return null;
  }
  return <Outlet />;
};
